import React from "react";

const NotFoundView = () => {
  return <h1 data-testid={`notFoundView_view`}>404 not found</h1>;
};

export default NotFoundView;
